import { render, staticRenderFns } from "./TableViewOverview.vue?vue&type=template&id=52d809e6&"
import script from "./TableViewOverview.vue?vue&type=script&lang=ts&"
export * from "./TableViewOverview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports